import { useEffect, useState } from "react";
import { SinisterNegotiationService } from "../../../shared/services/api/sinister/SinisterNegotiationService";
import { SinisterSector } from "../constants/sectorOptions";

type Option = {
	id: string;
	label: string;
};

// Opções de responsável pela cobrança, já filtradas por setor de atuação (cobrança/jurídico) no
// backend — ver PR-08-cobranca-responsavel-por-setor-frontend.md.
export function useCollectionResponsibleOptions(sector: SinisterSector, searchTerm: string) {
	const [options, setOptions] = useState<Option[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const timeout = setTimeout(() => {
			setLoading(true);

			SinisterNegotiationService.getResponsibleOptions(sector, searchTerm.trim()).then((result) => {
				if (!(result instanceof Error)) {
					setOptions(result.map((user) => ({ id: user.id, label: user.name })));
				}
				setLoading(false);
			});
		}, 400);

		return () => clearTimeout(timeout);
	}, [sector, searchTerm]);

	return { responsibleOptions: options, loading };
}
